import { functionCollectBrowserData } from "./browserData/functionCollectBrowserData";

export const generateCodeChallenge = async (v: string) => {
  // 1. Преобразование строки в ASCII (Uint8Array)
  const encoder = new TextEncoder();
  const data = encoder.encode(v);
  // 2. Вычисление SHA-256 хеша
  const digest = await window.crypto.subtle.digest('SHA-256', data);
  // 3. Base64URL-кодирование
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
} 

export const athena_state = 'athena_state';

export const getDeviceIdForAuth = async () => {
  const idFromStorage = localStorage.getItem('device_id');
  if (idFromStorage) {
    return idFromStorage;
  } else {
    const browserData = await functionCollectBrowserData();  
    const device_id = await generateCodeChallenge(JSON.stringify(browserData));
    localStorage.setItem('device_id', device_id);
    return device_id
  }
}
